import { Box, SpaceBetween, Table } from '@amzn/awsui-components-console';
import React from 'react';
import { HelpPanelInfoLink } from 'src/components/helpers';
import GroupNameAccess from 'src/components/helpers/GroupNameAccess';
import InternalLink from 'src/components/helpers/InternalLink';
import { useDownstreamActivityPreconditions } from 'src/data/redux';
import PAGES from 'src/nav/Pages';

export default function DownstreamActivityPreconditions(props: { activityId: string }) {
	const { data: downstreamActivityPreconditions, fetching: fetchingDownstreamActivities } =
		useDownstreamActivityPreconditions(props.activityId);
	return (
		<SpaceBetween size="xs">
			<Table
				header="Downstream activity dependencies"
				loading={fetchingDownstreamActivities}
				loadingText="Fetching downstream activity dependencies..."
				empty="No downstream activities are dependent on this activity."
				columnDefinitions={[
					{
						id: 'activityId',
						header: 'Activity ID',
						cell: ({ activityId, groupName }) => (
							<InternalLink
								href={PAGES.VIEW_ACTIVITY.path}
								pathParams={{ activityId }}
								groupName={groupName}
							>
								{activityId}
							</InternalLink>
						),
					},
					{
						id: 'activityName',
						header: 'Activity name',
						cell: ({ activityName }) => activityName,
					},
					{
						id: 'pipelineName',
						header: 'Pipeline name',
						// Link intentionally omitted for pipeline to maintain consistency with upstream preconditions above.
						// Customers can access pipeline by clicking thru activity link.
						cell: ({ pipelineName }) => pipelineName,
					},
					{
						id: 'groupName',
						header: 'Group name',
						// NOTE: Instead of inconsistently showing links to downstream activities based on whether
						// we expect customers to have access, we render all links and provide a locked icon with a popover
						// indicating that the customer does not have access to that parciular Hammerstone group
						cell: ({ groupName }) => <GroupNameAccess groupName={groupName} />,
					},
					{
						id: 'preconditionExpression',
						header: 'Precondition expression (relative schedule)',
						cell: (item) => item.preconditionExpression,
					},
				]}
				items={downstreamActivityPreconditions}
			/>
			<Box variant="small">
				For more information about upstream and downstream preconditions click the{' '}
				<HelpPanelInfoLink helpPanel="Preconditions" /> link above
			</Box>
		</SpaceBetween>
	);
}
